import { Amplify } from "aws-amplify"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import "@/assets/css/index.css"
import "@/assets/css/reset.css"
import "@/assets/css/theme.css"
import "@/assets/css/type.css"
import "@/utilities/i18n.ts"
import { RACLocaleProvider } from "@/utilities/hooks/RACLocaleProvider.tsx"

import App from "./App.tsx"
import { ErrorModalProvider } from "./utilities/hooks/ErrorModalProvider.tsx"
import { ThemeProvider } from "./utilities/hooks/ThemeProvider.tsx"

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolClientId: import.meta.env.VITE_COGNITO_APP_CLIENT_ID,
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
    },
  },
})

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RACLocaleProvider>
      <ThemeProvider>
        <ErrorModalProvider>
          <App />
        </ErrorModalProvider>
      </ThemeProvider>
    </RACLocaleProvider>
  </StrictMode>
)
